import { useDocumentTitle } from 'usehooks-ts';

export function useTitle(title: string) {
  useDocumentTitle(`${title} - Supersimple`);
}
